export default "Calorifugeage BAT-TH-146 — Points singuliers chaufferie tertiaire | Solution Éco France";
